<div class="camera-shell" [class.modal-mode]="modalMode">
  <header class="camera-header">
    <div class="camera-controls">
      @if (devices.length > 1) {
        <select [(ngModel)]="selectedDeviceId" (ngModelChange)="startStream()" aria-label="Camera device">
          @for (device of devices; track device.deviceId; let index = $index) {
            <option [value]="device.deviceId">{{ device.label || 'Camera ' + (index + 1) }}</option>
          }
        </select>
      }
      <div class="handedness">
        <button type="button" [class.active]="captureButtonPosition === 'left'" (click)="setHandedness('left')">Left</button>
        <button type="button" [class.active]="captureButtonPosition === 'right'" (click)="setHandedness('right')">Right</button>
      </div>
      @if (modalMode) {
        <button type="button" class="camera-close-button" (click)="closeWindow()" aria-label="Close camera">x</button>
      }
    </div>
    <div class="camera-title">
      <h1>{{ job?.address || 'Loading...' }}</h1>
      @if (job?.jobNumber) {
        <p>TOPS Job #{{ job!.jobNumber }}</p>
      }
    </div>
  </header>

  @if (!formAlive) {
    <div class="closed-warning">Form closed. Re-open the camera from the job.</div>
  }

  <main class="camera-body">
    @if (captureButtonPosition === 'left') {
      <ng-container *ngTemplateOutlet="captureButton" />
    }

    <section class="recent-photos">
      <header style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <div class="photos-header-left">
          Photos pending sync <span>({{ photos.length }})</span>
        </div>
        <div style="width:40%;">
          <select [(ngModel)]="selectedBuildingId" (ngModelChange)="onBuildingChange()" aria-label="Photo filter or option">
            @if (buildings.length === 0) {
              <option value="">No Dwellings found...</option>
            } @else {
              <option value="">Select a Dwelling...</option>
              @for (building of buildings; track building.id) {
                <option [value]="building.id">
                  {{ building.dwellingName || 'Unnamed Dwelling' }}
                </option>
            }
          }
          </select>
        </div>
       
      </header>

      <div class="recent-grid">
        @for (photo of photos; track photo.id) {
          <article class="recent-photo-item" (click)="openPhotoEdit(photo)" tabindex="0" role="button" (keydown.enter)="openPhotoEdit(photo)" (keydown.space)="openPhotoEdit(photo)" aria-label="Edit {{ photo.label || 'photo' }}">
            <button type="button" class="thumbnail-delete" (click)="deletePhoto($event, photo)" [disabled]="deletingPhotoId === photo.id" aria-label="Delete {{ photo.label || 'photo' }}">x</button>
            <img [src]="photoSource(photo)" [alt]="photo.label || 'Photo'" />
            <p>{{ photo.label || 'Photo' }}</p>
          </article>
        } @empty {
          <p>No unsynced photos on this device.</p>
        }
      </div>
    </section>

    <section class="viewfinder">
      <video #video autoplay playsinline muted></video>
      @if (cameraStarting || cameraError) {
        <div class="camera-status" [class.error-status]="cameraError">
          <h2>{{ cameraError ? 'Camera unavailable' : 'Starting camera...' }}</h2>
          @if (cameraError) {
            <p>{{ cameraError }}</p>
            <button type="button" (click)="startStream()">Retry</button>
          }
        </div>
      }
      <canvas #canvas hidden></canvas>
    </section>

    @if (captureButtonPosition === 'right') {
      <ng-container *ngTemplateOutlet="captureButton" />
    }
  </main>
</div>

<ng-template #captureButton>
  <div class="capture-column">
    <button type="button" class="capture-button" (click)="capture()" [disabled]="capturing || !!pendingPhotoData || !formAlive || !stream">
      <span>{{ capturing ? 'PROCESSING' : 'CAPTURE' }}</span>
    </button>
  </div>
</ng-template>

@if (pendingPhotoData) {
  <div class="photo-review-backdrop" role="presentation">
    <section class="photo-review-modal" role="dialog" aria-modal="true" aria-label="Review captured photo">
      <header>
        <h2>Review Photo</h2>
      </header>

      <img [src]="pendingPhotoData" alt="Captured photo preview" />

      <label>
        <span>Image Name</span>
        <input [(ngModel)]="pendingPhotoName" [disabled]="savingPendingPhoto" />
      </label>

      <label>
        <span>Image Type</span>
        @if (imageList.length) {
          <select [(ngModel)]="pendingPhotoImageType" [disabled]="savingPendingPhoto" aria-label="Image type">
            <option value="">Select an image type...</option>
            @for (image of imageList; track image.value) {
              <option [value]="image.value">{{ image.label }}</option>
            }
          </select>
        } @else {
          <input [(ngModel)]="pendingPhotoImageType" [disabled]="savingPendingPhoto" />
        }
      </label>

      <label>
        <span>Display Order</span>
        <select [(ngModel)]="pendingPhotoDisplayOrder" [disabled]="savingPendingPhoto" aria-label="Display order">
          <option value="">Select display order...</option>
          @for (displayOrder of displayOrderOptions; track displayOrder) {
            <option [value]="displayOrder">{{ displayOrder }}</option>
          }
        </select>
      </label>

      <footer>
        <button type="button" class="review-cancel" (click)="cancelPendingPhoto()" [disabled]="savingPendingPhoto">Cancel</button>
        <button type="button" class="review-save" (click)="savePendingPhoto()" [disabled]="savingPendingPhoto">
          {{ savingPendingPhoto ? 'Saving...' : 'Save' }}
        </button>
      </footer>
    </section>
  </div>
}

@if (editingPhoto) {
  <div class="photo-review-backdrop" role="presentation">
    <section class="photo-review-modal" role="dialog" aria-modal="true" aria-label="Edit photo details">
      <header>
        <h2>Edit Photo</h2>
      </header>

      <img [src]="photoSource(editingPhoto)" [alt]="editingPhoto.label || 'Photo preview'" />

      <label>
        <span>Image Name</span>
        <input [(ngModel)]="editingPhotoName" [disabled]="savingPhotoEdit" />
      </label>

      <label>
        <span>Image Type</span>
        @if (imageList.length) {
          <select [(ngModel)]="editingPhotoImageType" [disabled]="savingPhotoEdit" aria-label="Image type">
            <option value="">Select an image type...</option>
            @for (image of imageList; track image.value) {
              <option [value]="image.value">{{ image.label }}</option>
            }
          </select>
        } @else {
          <input [(ngModel)]="editingPhotoImageType" [disabled]="savingPhotoEdit" />
        }
      </label>

      <label>
        <span>Display Order</span>
        <select [(ngModel)]="editingPhotoDisplayOrder" [disabled]="savingPhotoEdit" aria-label="Display order">
          <option value="">Select display order...</option>
          @for (displayOrder of displayOrderOptions; track displayOrder) {
            <option [value]="displayOrder">{{ displayOrder }}</option>
          }
        </select>
      </label>

      <footer>
        <button type="button" class="review-cancel" (click)="closePhotoEdit()" [disabled]="savingPhotoEdit">Cancel</button>
        <button type="button" class="review-save" (click)="savePhotoEdit()" [disabled]="savingPhotoEdit">
          {{ savingPhotoEdit ? 'Saving...' : 'Save' }}
        </button>
      </footer>
    </section>
  </div>
}